import { render, staticRenderFns } from "./RolePushBtnModal.vue?vue&type=template&id=f95b5f46&scoped=true"
import script from "./RolePushBtnModal.vue?vue&type=script&lang=js"
export * from "./RolePushBtnModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f95b5f46",
  null
  
)

export default component.exports